import React, { useRef, useEffect } from "react";
import World from "../../../../assets/svg-maps/world.robinson";
import chroma from "chroma-js";
import countries from "i18n-iso-countries";
import styled from "styled-components";

import { colors, LegendColor } from "../../../../theme";
import Map from "../../../dataviz/DataMap";
import { data, scales } from "./assets/data.json";

const Container = styled.div`
  margin: 40px 0 60px;

  @media (max-width: 767px) {
    margin: 40px 0 50px;
  }
`;

const Legend = styled.div`
  color: ${colors.textColor};
  margin: 15px auto 0;
  width: 85%;

  @media (max-width: 1023px) {
    width: 90%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }

  h1 {
    color: black;
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    font-size: 1.3rem;
    display: inline-block;
    line-height: 2.4rem;
    width: 50%;

    @media (max-width: 767px) {
      width: 100%;
    }
  }
`;

const scale = scales.tests_per_thousand;
const scaleColor = [
  colors.darkBlue,
  chroma(colors.blue).darken(0.25),
  chroma(colors.blue).brighten(0.75),
  chroma(colors.red).brighten(2),
  chroma(colors.red).darken(0.1),
];

function getLocationColor(countryId) {
  const value = data[countryId] && data[countryId].tests_per_thousand;

  if (!value) {
    return chroma(colors.borderColor).brighten(0.6);
  } else if (value < scale[1]) {
    return scaleColor[4];
  } else if (value < scale[2]) {
    return scaleColor[3];
  } else if (value < scale[3]) {
    return scaleColor[2];
  } else if (value < scale[4]) {
    return scaleColor[1];
  } else {
    return scaleColor[0];
  }
}

function getTooltipContent(countryId) {
  return {
    title: (
      <>
        <span className={`flag-icon flag-icon-${countryId.toLowerCase()}`} />
        {countries.getName(countryId, "fr")}
      </>
    ),
    mainContent: data[countryId] && data[countryId].tests_per_thousand && (
      <>
        Tests par millier d'habitants :{" "}
        <span>
          {data[countryId].tests_per_thousand.toString().replace(".", ",")}
        </span>
      </>
    ),
    color: getLocationColor(countryId),
  };
}

function CovidWorldResponseTestPerCapita() {
  const mapRef = useRef(null);

  useEffect(() => {
    Object.keys(data).forEach((countryId) => {
      const el = mapRef.current.querySelector(`path[id="${countryId}"]`);
      if (el) {
        el.style.fill = getLocationColor(countryId);
      }
    });
  }, []);

  return (
    <Container>
      <Map
        map={World}
        containerRef={mapRef}
        getTooltipContent={getTooltipContent}
      />
      <Legend>
        <h1>Tests pratiqués par millier d'habitants</h1>
        <ul>
          <li>
            <LegendColor color={scaleColor[4]} /> Entre {scale[0]} et{" "}
            {scale[1] - 1} par millier d'habitants
          </li>
          <li>
            <LegendColor color={scaleColor[3]} /> Entre {scale[1]} et{" "}
            {scale[2] - 1} par millier d'habitants
          </li>
          <li>
            <LegendColor color={scaleColor[2]} /> Entre {scale[2]} et{" "}
            {scale[3] - 1} par millier d'habitants
          </li>
          <li>
            <LegendColor color={scaleColor[1]} /> Entre {scale[3]} et{" "}
            {scale[4] - 1} par millier d'habitants
          </li>
          <li>
            <LegendColor color={scaleColor[0]} /> Entre {scale[4]} et {scale[5]}{" "}
            par millier d'habitants
          </li>
          <li>
            <LegendColor color={chroma(colors.borderColor).brighten(0.6)} /> Non
            référencé
          </li>
        </ul>
      </Legend>
    </Container>
  );
}

export default CovidWorldResponseTestPerCapita;
